import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";

/**
 * Base view with common fields for all BusinessType views.
 * Extended by BusinessTypeManagementView and related views.
 */
export class BusinessTypeBaseView {
    id: number;
    type: number;
    categoryType: number;
    status: number;
    autoAccept: boolean;
    translatedName: MessageBaseView;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.type = data?.type ?? 0;
        this.categoryType = data?.categoryType ?? 0;
        this.status = data?.status ?? 0;
        this.autoAccept = data?.autoAccept ?? false;
        this.translatedName = data?.translatedName ? new MessageBaseView(data.translatedName) : new MessageBaseView();
    }
}
